import { lazy } from "react";

const ClientesLayout = lazy(() => import("../../clientes/ClientesLayout.jsx"));

const ClientesList = lazy(() => import("../../clientes/Clientes.jsx"));
const ClienteForm = lazy(() => import("../../clientes/ClienteForm.jsx"));
const ClienteOp = lazy(() => import("../../clientes/ClienteOp.jsx"));
const ClienteVentas = lazy(() => import("../../clientes/Ventas.jsx"));
const ClienteCotizaciones = lazy(() => import("../../clientes/Cotizaciones.jsx"));
const OrdenesTrabajoCliente = lazy(() => import("../../clientes/OrdenesTrabajoCliente.jsx"));
const PuntosCliente = lazy(() => import("../../clientes/Puntos.jsx"));
const GuiasDespachoCliente = lazy(() =>
      import("../../guias-despacho/GuiasDespachoCliente.jsx")
);

const clientesRoutes = [
      {
            path: "clientes",
            element: <ClientesLayout />,
            children: [
                  { index: true, element: <ClientesList /> },
                  { path: "nuevo", element: <ClienteForm /> },
                  { path: "editar", element: <ClienteForm /> },
                  { path: "view/:token", element: <ClienteOp /> },
                  { path: "ventas/:token", element: <ClienteVentas /> },
                  { path: "guias/:token", element: <GuiasDespachoCliente /> },
                  { path: "cotizaciones/:token", element: <ClienteCotizaciones /> },
                  { path: "ordenes-trabajo/:token", element: <OrdenesTrabajoCliente /> },
                  { path: "puntos/:token", element: <PuntosCliente /> },
            ],
      },
];

export default clientesRoutes;